import type { ActivitySubject } from '@aimmo/contracts';

/** Where each kind of record an activity hangs off lives in the SPA. */
export const SUBJECT_ROUTES = {
  contact: '/contatti/$id',
  property: '/immobili/$id',
  mandate: '/incarichi/$id',
  demand: '/richieste/$id',
} as const satisfies Record<ActivitySubject, string>;

/** A link to an activity's subject, ready to spread onto `<Link>`. */
export function subjectLink(subjectType: ActivitySubject, subjectId: string) {
  return { to: SUBJECT_ROUTES[subjectType], params: { id: subjectId } };
}
